// @flow
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import Attributes from 'esm-web-pro/components/layout/sidePanel/Attributes';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import type { GisPoint } from 'esm-web-pro/containers/pages/network/objects/gispoint/GisPoint';
import attributeMessages from 'esm-web-pro/messages/attributeMessages';
import { transformPointCoords } from 'esm-web-pro/containers/pages/network/Util';
import { getCoordinateSystem } from 'esm-web-pro/redux/networks';
import { connect } from 'react-redux';

type Props = {
    point: GisPoint,
    coordinateSystem: string,
    intl: IntlShape,
}

const GisPointAttributes = (props: Props) => {
    const { point, intl: { formatMessage }, coordinateSystem } = props;
    const {
        description,
        alias,
        coordinates,
    } = point;
    const location = useLocation();
    const attributes = [
        {
            label: formatMessage(attributeMessages.description),
            value: description,
        },
        {
            label: formatMessage(attributeMessages.coordinates),
            value: coordinateSystem === process.env.REACT_APP_GIS_TRANSFORM_COORDINATE_SYSTEM
                ? transformPointCoords(coordinates.coordinates).slice().reverse().join(', ')
                : coordinates.coordinates.slice().reverse().join(', '),
        },
    ];

    if (alias) {
        attributes.push({
            label: formatMessage(attributeMessages.alias),
            value: alias,
        });
    }
    if (point.regions) {
        attributes.push(
            {
                label: (
                    <FormattedMessage
                        id="map-regions"
                        defaultMessage="Regions"
                    />
                ),
                multiValue: point.regions.map((region) => ({
                    value: region.name,
                    link: region.uuid ? `/infrastructure/map/${point.map_identity}/${
                        location.pathname.includes('active')
                            ? 'active' : 'draft'}/layer/region/${
                        region.uuid}` : null,
                })),
                separator: ', ',
            },
        );
    }

    return (
        <Attributes attributes={attributes} />
    );
};

const mapStateToProps = (state) => ({ coordinateSystem: getCoordinateSystem(state) });

export default connect(mapStateToProps)(injectIntl(GisPointAttributes));
